/**
 * Human-readable labels for a horizon offset.
 * 0 = intraday; >=1 = day-ahead D+N.
 */
export function horizonLabel(n) {
  if (n === null || n === undefined) return null;
  if (n === 0) return 'Intraday';
  return `Day-Ahead (D+${n})`;
}

export function horizonShortLabel(n) {
  if (n === null || n === undefined) return null;
  if (n === 0) return 'ID';
  return `D+${n}`;
}
